module.exports = __webpack_public_path__ + "static/img/tmall_logo.2c8816a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tmall_logo.png
// module id = F5YM
// module chunks = 2